import { blueGrey } from "../../../../mp-core/themes/palette"
import { makeStyles } from "tss-react/mui"
import { TOTAL_SCORE_CIRCLE_CLASSNAME } from "./components/Score/styles"

interface StyleProps {
  subjects: string[]
  size?: number
}

type RuleName =
  | "mainContainer"
  | "subjectContainer"
  | "subjectSelected"
  | "sectionScorePlaceholder"
  | "scoreContainer"
  | "svgContainer"
  | "totalScoreContainer"
  | "totalScorePlaceholder"
  | "sectionLabel"
  | "loadingBox"
  | "scoreText"
  | "totalScoreText"

export const useStyles = makeStyles<StyleProps, RuleName>()(
  ({ palette, spacing }, { subjects = [], size = 86 }, classes) => ({
    mainContainer: {
      margin: "4px 0",
      backgroundColor: "transparent",
      display: "flex",
      position: "relative"
    },
    subjectContainer: {
      backgroundColor: palette.common.white,
      paddingLeft: spacing(4),
      paddingRight: `calc(${size / 2}px + ${spacing(4)})`,
      paddingTop: spacing(4),
      paddingBottom: spacing(4),
      justifyContent: "center",
      alignItems: "center",
      display: "flex",
      flexDirection: "column",
      borderTopLeftRadius: 25,
      borderBottomLeftRadius: 25,
      border: `1px solid ${blueGrey[50]}`,
      marginRight: `-${size / 2}px`,

      ...(subjects.length === 2 && {
        paddingLeft: "20px",
        borderRadius: 5,
        border: "none",
        marginRight: 0
      }),

      ...(subjects.length > 2 && {
        [`&:has(.${classes.sectionScorePlaceholder})`]: {
          paddingLeft: spacing(2),
          paddingRight: `calc(${size / 2}px + ${spacing(2)})`
        }
      }),

      ...subjects.reduce(
        (acc, subject, i) => ({
          ...acc,
          [`&:nth-of-type(${i + 1})`]: {
            ...(subjects.length === 2 && {
              order: i,

              ...(i === 1 && {
                paddingLeft: `calc(${size / 2}px + ${spacing(4)})`,
                paddingRight: "20px"
              })
            }),

            [`&.${classes.subjectSelected}`]: {
              backgroundColor: subject
            }
          }
        }),
        {}
      ),

      "&:hover": {
        background: blueGrey[50],
        "& > div": {
          backgroundColor: blueGrey[200]
        }
      }
    },
    subjectSelected: {},
    sectionScorePlaceholder: {
      width: 32,
      height: 20,
      borderRadius: 10,
      backgroundColor: blueGrey[50],

      ...(subjects.length === 2 && {
        height: 16,
        borderRadius: 8
      })
    },
    scoreContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1,
      position: "relative",

      ...(subjects.length === 2 && {
        order: 0,
        margin: `3px -${size / 2}px`
      }),

      [`&:has(.${TOTAL_SCORE_CIRCLE_CLASSNAME}:hover) .${classes.totalScorePlaceholder}`]:
        {
          backgroundColor: blueGrey[200]
        }
    },
    svgContainer: {
      display: "flex"
    },
    totalScoreContainer: {
      position: "absolute",
      left: "50%",
      top: "50%",
      transform: "translate(-50%, -50%)",
      alignItems: "center",
      justifyContent: "center",
      pointerEvents: "none"
    },
    totalScorePlaceholder: {
      width: 40,
      height: 20,
      borderRadius: 10,
      backgroundColor: blueGrey[50]
    },
    sectionLabel: {
      fontSize: "0.6875rem",
      lineHeight: "0.75rem",
      fontWeight: 500,
      color: blueGrey[800],
      marginTop: 4,
      cursor: "default",
      userSelect: "none"
    },
    loadingBox: {
      display: "flex",
      width: size,
      height: size,
      alignItems: "center",
      justifyContent: "center"
    },
    scoreText: {
      fontSize: "1.125rem",
      lineHeight: "1.125rem",
      fontWeight: 500,
      color: blueGrey[800],
      cursor: "default",
      userSelect: "none"
    },
    totalScoreText: {
      fontSize: "1.125rem",
      lineHeight: "1.125rem",
      cursor: "default",
      userSelect: "none",

      ...(subjects.length === 2 && {
        fontSize: "1.5rem",
        lineHeight: "1.5rem"
      })
    }
  })
)
